import { render, staticRenderFns } from "./NutrientAmountSelection.vue?vue&type=template&id=4218c34c&scoped=true&"
import script from "./NutrientAmountSelection.vue?vue&type=script&lang=ts&"
export * from "./NutrientAmountSelection.vue?vue&type=script&lang=ts&"
import style0 from "./NutrientAmountSelection.vue?vue&type=style&index=0&id=4218c34c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4218c34c",
  null
  
)

export default component.exports